// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomButtons_wrapper__wnYl7","left":"BottomButtons_left__wa8aJ","right":"BottomButtons_right__FP+zv"};